import type { PermissionGated, PermissionGatedSection } from 'src/interfaces/internalAccess'
import { hasAnyPermission } from './hasAnyPermission'

export const filterByPermission = <Item extends PermissionGated>(
  items: Item[],
  permissions: string[],
): Item[] => {
  return items.filter((item) => {
    return hasAnyPermission(permissions, item.requiredAnyPermission)
  })
}

/** A rail group whose every item is hidden is dropped, so no empty heading is left behind. */
export const filterSectionsByPermission = <Item extends PermissionGated>(
  sections: PermissionGatedSection<Item>[],
  permissions: string[],
): PermissionGatedSection<Item>[] => {
  return sections
    .map((section) => {
      return { label: section.label, items: filterByPermission(section.items, permissions) }
    })
    .filter((section) => {
      return section.items.length > 0
    })
}
